<div class="p-grid">
    <div class="col-sm" style="text-align: center;">
        <h1>Club de Karate Do Tigre Rojo</h1>
    </div>
</div>
<div class="p-grid">

    <img src="../../../assets/img/karate/IMG_20201215_162914.jpg" class="img-galeria" alt="TigreRojo">
    <img src="../../../assets/img/karate/IMG_20201215_162947.jpg" class="img-galeria" alt="TigreRojo">
    <img src="../../../assets/img/karate/IMG_20201215_163114.jpg" class="img-galeria" alt="TigreRojo">
    <img src="../../../assets/img/karate/IMG_20201221_171349.jpg" class="img-galeria" alt="TigreRojo">
    <img src="../../../assets/img/karate/IMG_20201221_171439.jpg" class="img-galeria" alt="TigreRojo">
    <img src="../../../assets/img/karate/IMG_20201221_171805.jpg" class="img-galeria" alt="TigreRojo">
</div>